Profiling.Dashboard ||= {}

class Profiling.Dashboard.DashboardView extends Backbone.View
  template: JST["backbone/templates/profiling/dashboard"]
  className: 'dashboard'
  id: 'monitoring-dashboard'
  events:
    'click #start-new-session': 'newSearch'

  initialize: ({topics, uuid, session, availableChannelsByProvider, sessionList, profileTags}) ->
    @topics = topics
    @availableChannelsByProvider = availableChannelsByProvider
    @firstSearch = false
    @resultsElement = ''
    @scrollPosition = 0
    @filtersRendered = true
    @profileTags = notNull(profileTags)
    @chartsRendered = true
    @currentUser = Keepcon.currentUser.id
    @accountSettings = Keepcon.currentAccount.monitoringSettings
    @customerData = {
      settings: Keepcon.applicationSettings.customer,
      enabledForCurrentAccount: Keepcon.currentAccount.customerEnabled,
      users: Keepcon.customerUsers,
      usersGroups: Keepcon.customerUsersGroups
    }
    if session?
      @searchIsPending = true
      @changeSession(session)
    else
      @uuid = uuid
    @sessionList = sessionList || []
    @filterView = destroy: ->
    @results = destroy: ->
    $(window).on('resize', @adjustHeight)

  render: =>
    selectedTopics = []
    template = @template(
      activeTopics: @getActiveTopics(),
      inactiveTopics: @getInactiveTopics(),
      cleanTopicName: @cleanTopicName,
      selectedTopics: selectedTopics,
      uuid: @uuid,
      sortedAvailableChannelsByProvider: @getSortedAvailableChannelsByProvider(),
      twitterSubtypes: @getTwitterSubtypes()
    )
    @$el.html(template)
    if @mustCreateMyHistorySession()
      @createMyHistorySession()
    @updateSessionList(@sessionList)

    @adjustHeight()

    list = @$el.find('.dashboard-modes .btn')
    first_button = _.find(list, (e) -> $(e).css('display') != 'none' )
    $(first_button).addClass('active')
    @setAccountsOrTopics()
    @


  getAvailableChannels: =>
    _.flatten(channels for own provider, channels of @availableChannelsByProvider)

  updateSessionList: (sessions) =>
    @sessionList = sessions
    sessionListContainer = @$el.find('#session_list')
    @sessionListView = new Profiling.Sessions.ListView({sessions: @sessionList})
    @sessionListView.bind('destroyFromRestore', => @trigger('destroyFromRestore'))
    sessionListContainer.empty().append(@sessionListView.render().el)

  setAccountsOrTopics: ->
    analysisMode = @$el.find('.dashboard-modes button.active').attr('id') == 'analysis'
    @changeContentSelect(analysisMode)

  getActiveTopics: ->
    _.select(@topics, (topic) -> topic.started)

  getInactiveTopics: ->
    _.select(@topics, (topic) -> not topic.started)


  getSortedAvailableChannelsByProvider: =>
    ret = {}
    for own provider, channels of @availableChannelsByProvider
      ret[provider] = _.sortBy(channels, (c) -> (c.name || '').toLowerCase())
    ret

  destroy: ->
    @filterView.destroy()
    @deactivate()
    @results.destroy()
    $(window).off('resize', @adjustHeight)
    this.remove()

    return false


  getTwitterSubtypes: ->
    [
      { name: 'Tweets', value: 'tweet' },
      { name: 'Retweets', value: 'retweet' },
      { name: 'Replies', value: 'reply' },
      { name: 'Quotes', value: 'quote' }
    ]

  mustCreateMyHistorySession: =>
    not window.myHistoryCreated? and not @session? and @currentUserIsModerator() and @sessionList != [] and not ('My History' in _.pluck(@sessionList, 'name'))

  createMyHistorySession: =>
    @newSearchForMyHistorySession()

  currentUserIsModerator: ->
    return window.isModerator

  getActiveTopics: ->
    _.select(@topics, (topic) -> topic.started)

  getInactiveTopics: ->
    _.select(@topics, (topic) -> not topic.started)

  adjustHeight: =>
    headerHeight = $('#main-header').outerHeight(true)
    tabsHeight = $('#tabs-wrapper').outerHeight(true)
    @$el.find('.mini-scrollbar').css(
      'height',
      "calc(100vh - #{headerHeight + tabsHeight}px)"
    )


  selectedTopics: ->
    @$el.find('.select-view .tags .label').length > 0

  hasChannel: ->
    @$el.find('#select-channel :selected').length > 0

  getSelectedTopics: ->
    return []

  getSelectedChannels: ->
    availableChannels = @getAvailableChannels()
    _.map(@$el.find('#select-channel option:selected'), (selectedOption) ->
      _.find(availableChannels, (c) -> c.uid == $(selectedOption).val())
    )

  changeContentSelect: (analysisMode) ->
    @$el.find('.select-channel').toggleClass('hidden', !analysisMode)
    @$el.find('.select-topic').toggleClass('hidden', analysisMode)
    enableButton = @selectedTopics() && !analysisMode || @hasChannel() && analysisMode
    enableButton = enableButton && @twitterSubtypesCondition() if analysisMode
    @$el.find('#search_social_contents_btn').toggleClass('disabled', !enableButton)

  changeSession: (session) =>
    @session = session
    if @session
      @uuid = @session.uuid
      @uuid ||= @session.id

  isReviewMode: ->
    return false

  deactivate: ->
    @eventAggregator.unbind('editTopics', @onEditTopics)
    @scrollPosition = $(document.body).scrollTop()
    @resultsElement = @$el.find('#current_results').detach() if @filtersRendered unless @resultsElement

  activate: ->
    if @resultsElement
      @restoreResults()
      @resultsElement = ''
      setTimeout =>
        $(document.body).scrollTop(@scrollPosition)
      , 120
    else if @searchIsPending
      @doNewSearch()
    @eventAggregator.bind('editTopics', @onEditTopics)

  onFilterChanged:(session) =>
    @session = session
    @newSearch()

  restoreResults: ->
    @$el.find('#no_results').before(@resultsElement)

  newSearch: ->
    @doNewSearch()

  getSelectedSubtypes: =>
    selectedSubtypes = @$el.find('#select-twitter-subtype').chosen().find(':selected')
    selectedSubtypes = _.map(selectedSubtypes, (subtype) ->
      $(subtype).val()
    )
    selectedSubtypes || []

  createSearchQuery: ->
    exploreMode = @$el.find('#explore').hasClass('active')
    new Monitoring.Models.SearchQuery
      uuid: @uuid
      topics: @getSelectedTopics()
      exploreMode: exploreMode
      channels: @getSelectedChannels()
      post_sub_type: @getSelectedSubtypes()

  doNewSearch: (forMyHistorySession=false) ->
    @results.destroy()
    @firstSearch = true if !@session
    optionsForResultsView = {
      all:
        session: @session
        currentUser: @currentUser
        accountSettings: @accountSettings
        customerData: @customerData
      query: {}
    }

    @results = new Profiling.Dashboard.QueryView(
      $.extend({}, optionsForResultsView.all, optionsForResultsView.query)
    )
    @listenTo(@results, 'filterChanged', @onFilterChanged)
    @results.render()
    @$el.find('#results').append(@results.el)
    @results.bind('searchStarted', @startFilter)
    @results.bind('searchCompleted', @completeFilter)
    @$el.find('#results').append(@results.el)
    @results.bind('changeSession', @changeSession)
    @results.newSearch()
    @eventAggregator.trigger('sessionListChange')

  startFilter: =>
    @filtersRendered = false
    @chartsRendered = false
    window.scrollTo(0, 0)
    @$el.find('#topic-selector').hide()
    @$el.find('#dashboard-content').removeClass('hide')
    @$el.block()
    @$el.find('#filters').block()
    @$el.find('.top-nav-bar').addClass('disabled')

  completeFilter:(dashboardResults) =>
    @$el.find('.top-nav-bar').removeClass('disabled')
    @renderFilters(dashboardResults)
    @$el.unblock()
    @$el.find('#filters').unblock()
    @showResults()
    @_doCompleteSearch()

  showResults: ->
    @isChartPageActive = false
    # @eventAggregator.trigger('changeStateOnServer', @uuid, 'chart_active', false)
    @$el.find('#chart_report').addClass('hidden')
    @$el.find('#charts').addClass('hidden')
    @restoreResults() if @resultsElement
    @resultsElement = ''
    @$el.find('#results').removeClass('hidden')

  _doCompleteSearch: =>
    if @firstSearch
      @firstSearch = false
      if @results.session.name
        name = @results.session.name
        @trigger('firstSearch', name)
    @eventAggregator.trigger('contentReceived', @uuid)
    @eventAggregator.trigger('sessionListChange')

  loadFilters: (callback=->) ->
    #TODO filter facets

  renderFilters: (dashboardResults) =>
    @session = dashboardResults.session
    @filterView.destroy()
    @filterView = new Profiling.Dashboard.Filters.FiltersView
      session: @session
      profileTags: @profileTags
      facets: dashboardResults.facets
    @listenTo(@filterView, 'filterChanged', @onFilterChanged)
    @$el.find('#filters').append(@filterView.render().el)
    @filtersRendered = true
